module.exports = __webpack_public_path__ + "static/m_goals_exploring_art@2x-0aa9250d77e1c970f29b019a0e89372f.png";